import { cloneDeep } from 'lodash';
const SET_ACTIVE_UPGRADE_STEP = 'SET_ACTIVE_UPGRADE_STEP';
const UPGRADE_CHECKOUT 				= 'upgradeCheckout';
const UPGRADE_TERMS 					= 'upgradeTerms';

const initialState = UPGRADE_TERMS;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_ACTIVE_UPGRADE_STEP:
			return action.payload;
		default:
			return state;
	}
}

export function setActiveUpgradeStepTerms(){
	return{
		type: SET_ACTIVE_UPGRADE_STEP,
		payload: UPGRADE_TERMS
	}
}

export function setActiveUpgradeStepCheckout(){
	return{
		type: SET_ACTIVE_UPGRADE_STEP,
		payload: UPGRADE_CHECKOUT
	}
}


// WEBPACK FOOTER //
// ./src/modules/active_upgrade_step.js